import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from './views/Index'
import AssList from './views/assList'
import QRcode from './views/QRcode'
import KanbanLogin from './views/kanbanLogin'
import standard from './report/standard.vue'
import options from './report/options.vue'
import PreviewPDF from './utils/PreviewPDF.vue'
Vue.use(VueRouter)

const routes = [
    {
        path: '/PreviewPDF',
        name: 'PreviewPDF',
        component: PreviewPDF
    },
    {
        path: '/aqcaReport/:unionId',
        name: 'options',
        component: options
    },
    {
        path: '/aqcaReport/:unionId/:Id',
        name: 'standard',
        component: standard
    },
    {
        path: '/Kanban',
        name: 'kanbanLogin',
        component: KanbanLogin
    },
    {
        path: '/Kanban/:creator',
        name: 'index',
        component: Index
    },
    {
        path: '/assList/:userId',
        name: 'assList',
        component: AssList
    },
    {
        path: '/QRcode/:imgUrl/:assName',
        name: 'QRcode',
        component: QRcode
    }
]

const router = new VueRouter({
    routes
})

export default router